// Night sky renderer - draws twinkling stars, a soft moon top-right, drifting
// nebulae, and a left-side dark gradient onto #sky-canvas. The canvas is
// already positioned + z-indexed by index.css (fixed, inset:0, z-index:0).
//
// Light mode hides the canvas entirely via the CSS rule
//   :root[data-theme="light"] #sky-canvas { display: none; }
// so this renderer can run unconditionally; the GPU work is a no-op when
// the element is display:none.
//
// Distilled from the email-automation-decisions slideshow's inline script.
// Single IIFE auto-runs on import.

(function () {
  const canvas = document.getElementById('sky-canvas') as HTMLCanvasElement | null;
  if (!canvas) return;
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;

  function resize() {
    if (!canvas || !ctx) return;
    canvas.width = innerWidth * devicePixelRatio;
    canvas.height = innerHeight * devicePixelRatio;
    canvas.style.width = innerWidth + 'px';
    canvas.style.height = innerHeight + 'px';
    ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
  }
  resize();
  addEventListener('resize', resize);

  const stars: Array<{
    x: number; y: number; r: number;
    twinkleSpeed: number; twinklePhase: number; baseAlpha: number;
  }> = [];
  for (let i = 0; i < 220; i++) {
    stars.push({
      x: Math.random(),
      y: Math.random(),
      r: Math.random() * 1.5 + 0.3,
      twinkleSpeed: 0.5 + Math.random() * 2,
      twinklePhase: Math.random() * Math.PI * 2,
      baseAlpha: 0.3 + Math.random() * 0.7,
    });
  }

  const nebulae: Array<{
    x: number; y: number; r: number; dx: number; dy: number;
    hue: number; alpha: number;
  }> = [];
  for (let i = 0; i < 4; i++) {
    nebulae.push({
      x: Math.random(),
      y: Math.random() * 0.6,
      r: 0.15 + Math.random() * 0.15,
      dx: (Math.random() - 0.5) * 0.00003,
      dy: (Math.random() - 0.5) * 0.00002,
      hue: 210 + Math.random() * 40,
      alpha: 0.025 + Math.random() * 0.02,
    });
  }

  function draw(t: number) {
    if (!ctx) return;
    const W = innerWidth, H = innerHeight;
    ctx.clearRect(0, 0, W, H);

    // Left-side dark gradient (deepens contrast on the left edge)
    const darkGrad = ctx.createLinearGradient(0, 0, W * 0.4, 0);
    darkGrad.addColorStop(0, 'rgba(2, 4, 12, 0.55)');
    darkGrad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = darkGrad;
    ctx.fillRect(0, 0, W, H);

    // Drifting nebulae
    nebulae.forEach((n) => {
      n.x += n.dx; n.y += n.dy;
      if (n.x < -0.1) n.x = 1.1;
      if (n.x > 1.1) n.x = -0.1;
      if (n.y < -0.1) n.y = 0.7;
      if (n.y > 0.7) n.y = -0.1;
      const nx = n.x * W, ny = n.y * H, nr = n.r * W;
      const g = ctx.createRadialGradient(nx, ny, 0, nx, ny, nr);
      g.addColorStop(0, `hsla(${n.hue}, 60%, 40%, ${n.alpha})`);
      g.addColorStop(0.5, `hsla(${n.hue + 20}, 50%, 30%, ${n.alpha * 0.5})`);
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(nx, ny, nr, 0, Math.PI * 2);
      ctx.fill();
    });

    // Twinkling stars
    stars.forEach((st) => {
      const twinkle = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin(t * 0.001 * st.twinkleSpeed + st.twinklePhase));
      const a = st.baseAlpha * twinkle * 0.7;
      ctx.fillStyle = `rgba(220, 215, 235, ${a})`;
      ctx.beginPath();
      ctx.arc(st.x * W, st.y * H, st.r, 0, Math.PI * 2);
      ctx.fill();
    });

    // Moon top-right (radius + soft halo)
    const moonX = W * 0.92, moonY = H * 0.13, moonR = 11;
    const mg = ctx.createRadialGradient(moonX, moonY, moonR * 0.2, moonX, moonY, moonR * 4);
    mg.addColorStop(0, 'rgba(230, 225, 240, 0.7)');
    mg.addColorStop(0.3, 'rgba(200, 190, 220, 0.18)');
    mg.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = mg;
    ctx.beginPath();
    ctx.arc(moonX, moonY, moonR * 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = 'rgba(235, 230, 245, 0.92)';
    ctx.beginPath();
    ctx.arc(moonX, moonY, moonR, 0, Math.PI * 2);
    ctx.fill();

    requestAnimationFrame(draw);
  }
  requestAnimationFrame(draw);
})();
